import {configureStore} from '@reduxjs/toolkit';
import {createWrapper} from 'next-redux-wrapper';
import {baseApi} from 'core/redux/store/api';
import {rootReducer} from 'core/redux/reducers';
import {extraArgs} from 'core/redux/extra-args';
import {TAppStore} from 'core/redux/types';

export const makeStore = () => {
    return configureStore({
        devTools: true,
        reducer: {
            [baseApi.reducerPath]: baseApi.reducer,
            ...rootReducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                immutableCheck: false,
                serializableCheck: false,
                thunk: {
                    extraArgument: extraArgs,
                },
            }).concat(baseApi.middleware),
    });
};

export const wrapper = createWrapper<TAppStore>(makeStore, {
    debug: false,
});
